module.exports = __webpack_public_path__ + "img/pc_weixin.42965d5d.png";